import { QueryClient } from "react-query";

const minutes = 1000 * 60 * 1;
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: true,
            cacheTime: minutes,
            staleTime: minutes,
            refetchOnWindowFocus: true,
            refetchOnMount: false,
            refetchOnReconnect: true,
            retryDelay: 10000
        }
    }
});